import { IFabricationContract } from '../../store/ducks/fabrication-contracts/types';
import { ECustomerTypeView } from '../../store/ducks/user/types';
import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';
import { EGerdauService } from '../EGerdauService';

export class FabricationContractsService extends EGerdauService {
  async getContracts(
    customerViewType: ECustomerTypeView
  ): Promise<IFabricationContract[]> {
    const headers = super.getHeaders();

    const customerType =
      customerViewType === ECustomerTypeView.EMITTER
        ? customerViewType
        : ECustomerTypeView.RECEIVER;

    const contractsResponse = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.CONTRACTS_HEADERS}?status=aberto&customerType=${customerType}`,
      {
        headers
      }
    );

    return contractsResponse.data.items as IFabricationContract[];
  }

  async getContractsV2(): Promise<IFabricationContract[]> {
    const headers = super.getHeaders();

    const contractsResponse = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.CONTRACTS_HEADERS_V2}?status=aberto`,
      {
        headers
      }
    );

    return contractsResponse.data.items as IFabricationContract[];
  }

  async getContractDetails(
    contractNumber: string,
    customerShipToId?: string
  ): Promise<IFabricationContract> {
    const headers = super.getHeaders();

    const customerId = customerShipToId || '';
    const contractDetailResponse = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.CONTRACTS_V2}/${contractNumber}?customerId=${customerId}&customerType=shipTo`,
      { headers }
    );

    return contractDetailResponse.data as IFabricationContract;
  }

  async getOrderVersionReview(
    contractNumber: string,
    gerdauOrderNumber: number,
    isRevision: boolean
  ): Promise<IFabricationContract> {
    const headers = super.getHeaders();

    const newOrderVersionReview = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.CONTRACTS_V2}/${contractNumber}/${gerdauOrderNumber}/${isRevision}`,
      { headers }
    );

    return newOrderVersionReview.data as IFabricationContract;
  }

  async getRequestNewOrder(
    contractNumber: string
  ): Promise<IFabricationContract> {
    const headers = super.getHeaders();

    const orderNumber = '0'; // Default order number for versioning
    const isRevision = 'false'; // Default value for revision
    const newOrderVersion = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.CONTRACTS_V2}/${contractNumber}/${orderNumber}/${isRevision}`,
      { headers }
    );

    return newOrderVersion.data as IFabricationContract;
  }

  async getContractDetailsV2(
    contractNumber: string
  ): Promise<IFabricationContract> {
    const headers = super.getHeaders();

    const contractDetailResponse = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.CONTRACTS_V2}/${contractNumber}`,
      { headers }
    );

    return contractDetailResponse.data as IFabricationContract;
  }
}
